import { render } from "./mainFirst.vue?vue&type=template&id=3fe44bea&scoped=true"
import script from "./mainFirst.vue?vue&type=script&lang=js"
export * from "./mainFirst.vue?vue&type=script&lang=js"

import "./mainFirst.vue?vue&type=style&index=0&id=3fe44bea&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3fe44bea"

export default script